import { apiUrl } from '@/constants';
import axios from 'axios';

const state = {
  categories: [],
  message : '',
};

const mutations = {
  SET_CATEGORIES(state, categories) {
    state.categories = categories;
  },
  SUCCESS(state, message){
    state.message = message;
  }
  
};

const actions = {

  async deleteCategory({commit}, category){
    try {
      const token = localStorage.getItem('token');
      const response = await axios.delete(`${apiUrl}/categories/${category.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          },
      })
      commit('SUCCESS', response.data);
    } catch (error) {
      console.error('Error deleting category:', error);
    }
  },
  async addCategory({commit}, category){
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${apiUrl}/categories/`, category ,{
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      commit('SUCCESS', response.data);
      
    } catch (error) {
      console.error('Error adding category:', error);
    }
  },
  async editCategory({commit,dispatch}, category){
    await dispatch('setLoading', true, { root: true });
    try {
      const token = localStorage.getItem('token');
      const response = await axios.patch(`${apiUrl}/categories/${category.id}`, category ,{
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      commit('SUCCESS', response.data);

    }catch(error){
      console.error('Error editing category:', error);
    }finally{
      dispatch('setLoading', false, { root: true });
    }

  },
  async fetchCategories({commit, dispatch}){
    console.log('Fetching categories...', apiUrl);
    try {
      dispatch('setLoading', true, { root: true });
      const token = localStorage.getItem('token');
      const response = await axios.get(`${apiUrl}/categories` ,{
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      commit('SET_CATEGORIES', response.data);
      dispatch('setLoading', false, { root: true });
    } catch (error) {
      console.error('Error fetching category:', error);
    }finally{
      dispatch('setLoading', false, { root: true });
    }
  },
  
};

const getters = {
  getCategories: (state) => state.categories,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
